
// import React, { useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
// import Navbar from "../src/Components/Navbar";
// import Customer from "../src/Customer/index";
// import Card from "./Card";
// import Waiver from "./Waiver";
// import Enquiry from "./Enquiry";
// import ProductType from "./Product/ProductType";
// import Product from "./Product/Product";
// import PaymentType from "./PaymentType";
// import ReceiptSetting from "./ReceiptSetting/AddReceipt";
// import Discount from "./Discount";
// import DiscountReason from "./DiscountReason";
// import RefundReason from "./RefundReason";
// import PlayPoint from "./PlayPoint";
// import LoyalityPoints from "./LoyalityPoints";
// import MemberShip from "./MemberShip";
// import EmployeeList from "./Employee";
// import AddEmployee from "./Employee/AddEmployee";
// import Designation from "./Designation";
// import AddCenter from "./Location/AddCenter";
// import Dashboard from "./Dashboard";
// import Banner from "./Banner";
// import AddAccessRight from "./AccessRight/AddAccessRight";
// import AddSalesTab from "./SalesTab/AddSalesTab";
// import SalesTabList from "./SalesTab";
// import TaxRate from "./TaxRate/TaxRate";
// import Login from "./Login/Login";
// import AddIngredient from "./Ingredient/AddIngredient";
// import ManageInvetory from "./ManageInvetory/index";
// import Recipe from "./Recipe/index";
// import CardPrice from "./CardPrice/index";
// import FeedBack from "./Customer/FeedBack";
// import AddWaiver from "./Waiver/AddWaiver";
// import MachineMaster from "./MachineMaster/index"
// import ManageCenter from "./Location/ManageCenter"
// import IngredientList from "./Ingredient/index";
// import DiscountList from "./Discount/DiscountList";
// import MemberShipList from "./MemberShip/MemberShipList";
// import CenterList from "./Location";
// import AddRefund from "./Refund/AddRefund";
// import AddPackage from "./Package/AddPackage"
// import AddOn from "./Package/AddOnActivity"
// import ManagerCard from "./ManagerCard/ManagerCard";
// import PartyProduct from "./PartyProduct/PartyProduct";
// import PartyMenu from "./PartyProduct/PartyMenu";
// import Advance from "./PartyProduct/Advance";
// import FinanceReport from "./Report/FinanceReport";
// import Summary from "./Report/SummaryReport";
// import CustomerAnalyticsReport from "./Report/CustomerAnalyticsReport";
// import Coupon from "./Coupon";
// import PartyReport from "./Report/PartyReport";
// import FinanceReportCopy from "./Report/FinanceReportCopy";
// import AddOccasion from "./SpecialOccasion/AddOccasion"
// import Void from "./Void/index"
// import BirthdayParty from "./Report/BirthdayPartyReport"
// import VoidTransactionReport from "./Report/VoidTransactionReport"
// import InventoryLocationMap from "./Ingredient/InventoryLocationMap"
// import InventoryReport from "./Report/InventoryReport"
// import ProductMachineMapping from "./MachineMaster/ProductMachineMapping"
// import AuditReport from "./Report/AuditReport"
// const ScrollToTop = () => {
//   const { pathname } = useLocation();
//   useEffect(() => {
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "smooth", // smooth scroll
//     });
//   }, [pathname]);

//   return null;
// };

// const AppContent = () => {
//   const location = useLocation();
//   const isLoginPage = location.pathname === "/Login";
//   const isAddWaiverPage = location.pathname === "/AddWaiver";

//   return (
//     <>
//       <ScrollToTop />
//       {isLoginPage || isAddWaiverPage ? (
//         <Routes>
//           <Route path="/Login" element={<Login />} />
//           <Route path="/AddWaiver" element={<AddWaiver />}></Route>
//         </Routes>
//       ) : (
//         <Navbar>
//           <Routes>
//             <Route path="/" element={<Dashboard />} />
//             <Route path="/Customer" element={<Customer />} />
//             <Route path="/Card" element={<Card />} />
//             <Route path="/Waiver" element={<Waiver />} />
//             <Route path="/Enquiry" element={<Enquiry />} />
//             <Route path="/ProductType" element={<ProductType />} />
//             <Route path="/Product" element={<Product />} />
//             <Route path="/PaymentType" element={<PaymentType />} />
//             <Route path="/ReceiptSetting" element={<ReceiptSetting />} />
//             <Route path="/Discount" element={<Discount />} />
//             <Route path="/DiscountReason" element={<DiscountReason />} />
//             <Route path="/RefundReason" element={<RefundReason />} />
//             <Route path="/PlayPoint" element={<PlayPoint />} />
//             <Route path="/LoyalityPoints" element={<LoyalityPoints />} />
//             <Route path="/MemberShip" element={<MemberShip />} />
//             <Route path="/AddEmployee" element={<AddEmployee />} />
//             <Route path="/Designation" element={<Designation />} />
//             <Route path="/EmployeeList" element={<EmployeeList />} />
//             <Route path="/AddCenter" element={<AddCenter />} />
//             <Route path="/CenterList" element={<CenterList />} />
//             <Route path="/AddAccessRight" element={<AddAccessRight />} />
//             {/* <Route path="/AccessRightList" element={<AccessRightList />} /> */}
//             <Route path="/AddSalesTab" element={<AddSalesTab />} />
//             <Route path="/SalesTabList" element={<SalesTabList />} />
//             <Route path="/TaxRate" element={<TaxRate />} />
//             <Route path="/AddIngredient" element={<AddIngredient />} />
//             <Route path="/ManageInvetory" element={<ManageInvetory />} />
//             <Route path="/Recipe" element={<Recipe />} />
//             <Route path="/CardPrice" element={<CardPrice />} />
//             <Route path="/Banner" element={<Banner />} />
//             <Route path="/FeedBack" element={<FeedBack />} />
//             <Route path="/Dashboard" element={<Dashboard />} />
//             <Route path="/MachineMaster" element={<MachineMaster />} />
//             <Route path="/ManageCenter" element={<ManageCenter />} />
//             <Route path="/IngredientList" element={<IngredientList />} />
//             <Route path="/DiscountList" element={<DiscountList />} />
//             <Route path="/MemberShipList" element={<MemberShipList />} />
//             <Route path="/AddRefund" element={<AddRefund />} />
//             <Route path="/AddPackage" element={<AddPackage />} />
//             <Route path="/AddOn" element={<AddOn />} />
//             <Route path="/ManagerCard" element={<ManagerCard />} />
//             <Route path="/PartyProduct" element={<PartyProduct />} />
//             <Route path="/PartyMenu" element={<PartyMenu />} />
//             <Route path="/Advance" element={<Advance />} />
//             <Route path="/FinanceReport" element={<FinanceReport />} />
//             <Route path="/SummaryReport" element={<Summary />} />
//             <Route path="/CustomerAnalyticsReport" element={<CustomerAnalyticsReport />} />
//             <Route path="/PartyReport" element={<PartyReport />} />
//             <Route path="/Coupon" element={<Coupon />} />
//             <Route path="/FinanceReportCopy" element={<FinanceReportCopy />} />
//             <Route path="/AddOccasion" element={<AddOccasion />} />
//             <Route path="/VoidTransaction" element={<Void />} />
//             <Route path="/BirthdayParty" element={<BirthdayParty />} />
//             <Route path="/VoidTransactionReport" element={<VoidTransactionReport />} />
//             <Route path="/InventoryLocationMap" element={<InventoryLocationMap />} />
//             <Route path="/InventoryReport" element={<InventoryReport />} />
//             <Route path="/ProductMachineMapping" element={<ProductMachineMapping />} />
//             <Route path="/AuditReport" element={<AuditReport />}/>


//           </Routes>
//         </Navbar>
//       )}
//     </>
//   );
// };

// const App = () => {
//   return (
//     <Router>
//       <AppContent />
//     </Router>
//   );
// };

// export default App;
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Loader from "./Loader";

import Navbar from "../src/Components/Navbar";
import Customer from "../src/Customer/index";
import Card from "./Card";
import Waiver from "./Waiver";
import Enquiry from "./Enquiry";
import ProductType from "./Product/ProductType";
import Product from "./Product/Product";
import PaymentType from "./PaymentType";
import ReceiptSetting from "./ReceiptSetting/AddReceipt";
import Discount from "./Discount";
import DiscountReason from "./DiscountReason";
import RefundReason from "./RefundReason";
import PlayPoint from "./PlayPoint";
import LoyalityPoints from "./LoyalityPoints";
import MemberShip from "./MemberShip";
import EmployeeList from "./Employee";
import AddEmployee from "./Employee/AddEmployee";
import Designation from "./Designation";
import AddCenter from "./Location/AddCenter";
import Dashboard from "./Dashboard";
import Banner from "./Banner";
import AddAccessRight from "./AccessRight/AddAccessRight";
import AddSalesTab from "./SalesTab/AddSalesTab";
import SalesTabList from "./SalesTab";
import TaxRate from "./TaxRate/TaxRate";
import Login from "./Login/Login";
import AddIngredient from "./Ingredient/AddIngredient";
import ManageInvetory from "./ManageInvetory/index";
import Recipe from "./Recipe/index";
import CardPrice from "./CardPrice/index";
import FeedBack from "./Customer/FeedBack";
import AddWaiver from "./Waiver/AddWaiver";
import MachineMaster from "./MachineMaster/index";
import ManageCenter from "./Location/ManageCenter";
import IngredientList from "./Ingredient/index";
import DiscountList from "./Discount/DiscountList";
import MemberShipList from "./MemberShip/MemberShipList";
import CenterList from "./Location";
import AddRefund from "./Refund/AddRefund";
import AddPackage from "./Package/AddPackage";
import AddOn from "./Package/AddOnActivity";
import ManagerCard from "./ManagerCard/ManagerCard";
import PartyProduct from "./PartyProduct/PartyProduct";
import PartyMenu from "./PartyProduct/PartyMenu";
import Advance from "./PartyProduct/Advance";
import FinanceReport from "./Report/FinanceReport";
import Summary from "./Report/SummaryReport";
import CustomerAnalyticsReport from "./Report/CustomerAnalyticsReport";
import Coupon from "./Coupon";
import PartyReport from "./Report/PartyReport";
import FinanceReportCopy from "./Report/FinanceReportCopy";
import AddOccasion from "./SpecialOccasion/AddOccasion";
import Void from "./Void/index";
import BirthdayParty from "./Report/BirthdayPartyReport";
import VoidTransactionReport from "./Report/VoidTransactionReport";
import InventoryLocationMap from "./Ingredient/InventoryLocationMap";
import InventoryReport from "./Report/InventoryReport";
import ProductMachineMapping from "./MachineMaster/ProductMachineMapping";
import AuditReport from "./Report/AuditReport";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }, [pathname]);

    return null;
};

const AppContent = () => {

    const location = useLocation();
    const [loading, setLoading] = useState(false);
    useEffect(() => {

        const handleLoader = (e) => {
            setLoading(e.detail);
        };

        window.addEventListener("global-loader", handleLoader);

        return () => {
            window.removeEventListener("global-loader", handleLoader);
        };

    }, []);

    const isLoginPage = location.pathname === "/Login";
    const isAddWaiverPage = location.pathname === "/AddWaiver";

    return (
        <>
            {loading && <Loader />}

            <ScrollToTop />

            {isLoginPage || isAddWaiverPage ? (

                <Routes>
                    <Route path="/Login" element={<Login />} />
                    <Route path="/AddWaiver" element={<AddWaiver />} />
                </Routes>

            ) : (

                <Navbar>

                    <Routes>

                        <Route path="/" element={<Dashboard />} />
                        <Route path="/Dashboard" element={<Dashboard />} />

                        <Route path="/Customer" element={<Customer />} />
                        <Route path="/Card" element={<Card />} />
                        <Route path="/Waiver" element={<Waiver />} />
                        <Route path="/Enquiry" element={<Enquiry />} />
                        <Route path="/ProductType" element={<ProductType />} />
                        <Route path="/Product" element={<Product />} />
                        <Route path="/PaymentType" element={<PaymentType />} />
                        <Route path="/ReceiptSetting" element={<ReceiptSetting />} />
                        <Route path="/Discount" element={<Discount />} />
                        <Route path="/DiscountReason" element={<DiscountReason />} />
                        <Route path="/RefundReason" element={<RefundReason />} />
                        <Route path="/PlayPoint" element={<PlayPoint />} />
                        <Route path="/LoyalityPoints" element={<LoyalityPoints />} />
                        <Route path="/MemberShip" element={<MemberShip />} />
                        <Route path="/EmployeeList" element={<EmployeeList />} />
                        <Route path="/AddEmployee" element={<AddEmployee />} />
                        <Route path="/Designation" element={<Designation />} />
                        <Route path="/AddCenter" element={<AddCenter />} />
                        <Route path="/CenterList" element={<CenterList />} />
                        <Route path="/AddAccessRight" element={<AddAccessRight />} />
                        <Route path="/AddSalesTab" element={<AddSalesTab />} />
                        <Route path="/SalesTabList" element={<SalesTabList />} />
                        <Route path="/TaxRate" element={<TaxRate />} />
                        <Route path="/AddIngredient" element={<AddIngredient />} />
                        <Route path="/ManageInvetory" element={<ManageInvetory />} />
                        <Route path="/Recipe" element={<Recipe />} />
                        <Route path="/CardPrice" element={<CardPrice />} />
                        <Route path="/Banner" element={<Banner />} />
                        <Route path="/FeedBack" element={<FeedBack />} />
                        <Route path="/MachineMaster" element={<MachineMaster />} />
                        <Route path="/ManageCenter" element={<ManageCenter />} />
                        <Route path="/IngredientList" element={<IngredientList />} />
                        <Route path="/DiscountList" element={<DiscountList />} />
                        <Route path="/MemberShipList" element={<MemberShipList />} />
                        <Route path="/AddRefund" element={<AddRefund />} />
                        <Route path="/AddPackage" element={<AddPackage />} />
                        <Route path="/AddOn" element={<AddOn />} />
                        <Route path="/ManagerCard" element={<ManagerCard />} />
                        <Route path="/PartyProduct" element={<PartyProduct />} />
                        <Route path="/PartyMenu" element={<PartyMenu />} />
                        <Route path="/Advance" element={<Advance />} />
                        <Route path="/FinanceReport" element={<FinanceReport />} />
                        <Route path="/SummaryReport" element={<Summary />} />
                        <Route path="/CustomerAnalyticsReport" element={<CustomerAnalyticsReport />} />
                        <Route path="/PartyReport" element={<PartyReport />} />
                        <Route path="/Coupon" element={<Coupon />} />
                        <Route path="/FinanceReportCopy" element={<FinanceReportCopy />} />
                        <Route path="/AddOccasion" element={<AddOccasion />} />
                        <Route path="/VoidTransaction" element={<Void />} />
                        <Route path="/BirthdayParty" element={<BirthdayParty />} />
                        <Route path="/VoidTransactionReport" element={<VoidTransactionReport />} />
                        <Route path="/InventoryLocationMap" element={<InventoryLocationMap />} />
                        <Route path="/InventoryReport" element={<InventoryReport />} />
                        <Route path="/ProductMachineMapping" element={<ProductMachineMapping />} />
                        <Route path="/AuditReport" element={<AuditReport />} />

                    </Routes>

                </Navbar>

            )}

        </>
    );
};

const App = () => {
    return (
        <Router>
            <AppContent />
        </Router>
    );
};

export default App;